define('Store.ItemRelations.EntryPoint', [
    'Profile.Model',
    'underscore'
], function StoreItemRelationsEntryPoint(
    ProfileModel,
    _
) {
    'use strict';

    function filterData(data) {
        var profile;
        var store;
        var storeName;

        if (!data) {
            return data;
        }
        if (!data.items || !data.items.length) {
            return data;
        }

        profile = ProfileModel.getInstance();
        store = profile.get('store');
        storeName = store && store.get('name');

        if (!storeName) {
            return data;
        }

        data.items = _.filter(data.items || [], function filterItems(f) {
            if (f.correlateditems_detail && f.correlateditems_detail.length) {
                f.correlateditems_detail = _.filter(f.correlateditems_detail || [], function filterCorrelated(cr) {
                    return cr.custitem_sca_store.indexOf(storeName) !== -1;
                });
            }
            if (f.relateditems_detail && f.relateditems_detail.length) {
                f.relateditems_detail = _.filter(f.relateditems_detail || [], function filterRelated(r) {
                    return r.custitem_sca_store.indexOf(storeName) !== -1;
                });
            }
            if (f.custitem_sca_store) {
                return f.custitem_sca_store.indexOf(storeName) !== -1;
            }
            return true;
        });

        return data;
    }

    function enhanceCollection(collectionName) {
        var collection;
        try {
            // eslint-disable-next-line global-require
            collection = require(collectionName);
            if (collection && collection.prototype && collection.prototype.parse) {
                collection.prototype.parse = _.wrap(collection.prototype.parse, function (fn, responseData) {
                    var retFilter = filterData(responseData, collectionName);
                    return fn.apply(this, [retFilter]);
                });
                // Recently viewed is a quirky singleton
            } else if (collection && collection.getInstance && collection.getInstance()) {
                collection.getInstance().parse = _.wrap(collection.getInstance().parse, function (fn, responseData) {
                    var retFilter = filterData(responseData, collectionName);
                    return fn.apply(this, [retFilter]);
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    return {
        mountToApp: function mountToApp() {
            var collectionsToEnhance = [
                'ItemRelations.Related.Collection',
                'ItemRelations.Correlated.Collection',
                'RecentlyViewedItems.Collection'
            ];

            _.each(collectionsToEnhance, function eachCollectionToEnhance(c) {
                enhanceCollection(c);
            });
        }
    };
});
